import { useState } from "react";
import type { TabSortMode } from "../utils/sortTabList";

export const useTabSortV3 = () => {
  const [elementSort, setElementSort] = useState<TabSortMode>("smart");
  const [cableSort, setCableSort] = useState<TabSortMode>("smart");
  const [boardSort, setBoardSort] = useState<TabSortMode>("smart");

  return {
    elementSort,
    setElementSort,
    cableSort,
    setCableSort,
    boardSort,
    setBoardSort,
  };
};
